import { useAppSelector } from '@client/redux/hooks';
import { Illustration } from '@tkww/orion-web-ds-graphic';
import { TextBody, TextTitle } from '@tkww/orion-web-ds-text';
import React, { useContext } from 'react';
import { getVendorTerm } from '../../../../../../lib/mcvrm/utils';
import { CategoryRecommendationsContext } from '../CategoryRecommendationsProvider';
import Styles from './NoResults.scss';

const IllustrationAsset = Illustration as unknown as (props: {
	name: string;
	style?: React.CSSProperties;
	title?: string;
}) => React.ReactElement | null;

export const NoResults = () => {
	const { selectedCategoryCode } = useContext(CategoryRecommendationsContext);
	const categoryName = getVendorTerm(selectedCategoryCode || '', true, true);
	const location = useAppSelector((state) => state.location);

	return (
		<div className={Styles.container}>
			<IllustrationAsset
				name="oops-1"
				title="No Vendors Found"
				style={{
					width: '120px',
				}}
			/>
			<TextTitle size="sm">
				We didn't find any {categoryName.toLowerCase()} in{' '}
				{location?.city || 'your area'} to recommend
			</TextTitle>
			<TextBody>
				Explore the other categories to find vendors that match your style.
			</TextBody>
		</div>
	);
};
